var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    DnDZoneBorderWidth: borders.widthSmall,
    DnDZoneBorderColor: colors.contrasts.grey1214,
    DnDZoneBackgroundColor: colors.contrasts.grey1111,
    DnDZonePadding: spacing.medium,
    // sidebar:
    sidebarDnDZoneBorderWidth: borders.widthSmall,
    sidebarDnDZoneBorderColor: colors.contrasts.grey100100,
    sidebarDnDZoneBackgroundColor: colors.contrasts.grey1111,
    sidebarDnDZonePadding: spacing.small,
    sidebarDnDZoneMargin: spacing.xSmall,
    sidebarDnDZoneColor: colors.contrasts.grey125125
  };
};
export default generateComponentTheme;